import { XIcon } from "@heroicons/react/solid";

function Tag(props) {
    const { text, extraStyling, onDelete } = props;
  
    return (
        <div className={"text-xs font-medium text-primary-600 bg-primary-100 p-1 px-2 rounded-full flex justify-center items-center gap-1 " + extraStyling}>
            <span>{text}</span>
            <XIcon className="h-3 w-3 cursor-pointer" onClick={onDelete}/>
        </div>
    );
}

export default Tag;